import { render, staticRenderFns } from "./employee-leave-accruals-details.vue?vue&type=template&id=5cc14ede&"
import script from "./employee-leave-accruals-details.vue?vue&type=script&lang=js&"
export * from "./employee-leave-accruals-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports